<template>
  <mm-modal
    class="special-edition-tip-modal"
    title="打包激活须知"
    width="480px"
    destroy-on-close
    :esc-closable="false"
    :mask-closable="false"
    :visible.sync="visible"
    @close="handleClose"
  >
    <div class="special-edition-tip-modal-content">
      <div class="tips">
        <mm-alert
          type="warning"
          show-icon
          :closable="false"
        >
          <template #description>
            <span class="tips-content">
              您当前购买的是打包方案 OKKI特供版，激活订单将会同时生效 OKKI特供版Lite AI 和 OKKI特供版AiReach，请您确认是否激活。
              <a
                class="tips-content-link"
                @click="openOnlineService"
              >咨询客服</a>
            </span>
          </template>
        </mm-alert>
      </div>
      <div class="form-actions">
        <mm-button @click="handleClose">
          取消
        </mm-button>
        <mm-button
          type="primary"
          @click="handleConfirm"
        >
          我已确认
        </mm-button>
      </div>
    </div>
  </mm-modal>
</template>

<script>
import { mapState } from 'vuex'
import mainApi from '@api/main'
import qs from 'qs'

export default {
  name: 'SpecialEditionTipModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      planVersion: {},
    }
  },
  computed: {
    ...mapState('main', {
      userInfo: state => state.userInfo,
      isClientActive: state => state.isClientActive,
    }),
  },
  created() {
    this.isClientActive && this.fetchPlanVersion()
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleConfirm() {
      this.$emit('confirm')
    },
    fetchPlanVersion() {
      mainApi.fetchPlanVersion().then(data => {
        this.planVersion = data
      })
    },
    openOnlineService() {
      const SUPPORT_URL = 'https://support.okki.com';

      const {
        is_trial = 0,
        user_id = '',
        client_id = '',
        userId = '',
        email = '',
        family_name = '',
        second_name = '',
        user_language = 'zh-CN',
      } = this.userInfo;
      const languageMap = {
        'zh-CN': 'cn',
        'zh-TW': 'tw',
        en: 'en',
      };
      const planVersionContent = Number(is_trial)
        ? 'OKKI Lucky'
        : encodeURIComponent(
            [this.planVersion.system]
              .concat(this.planVersion.modules)
              .join('&'),
          );
      const visitUrl = encodeURIComponent(location.href);
      const zhichiConfig = {
        email,
        visitUrl,
        uname: email,
        partnerid: userId || user_id,
        locale: languageMap[user_language],
        realname: `${family_name} ${second_name}`,
        customer_fields: JSON.stringify({
          /**
           * 用户ID
           */
          customField2: userId || user_id,
          /**
           * 公司ID
           */
          customField3: client_id,
          /**
           * 版本信息
           */
          customField4: planVersionContent,
        }),
      };
      const openZhichiService = () => {
        window.open(`${SUPPORT_URL}?${qs.stringify(zhichiConfig)}`);
      };

      openZhichiService();
    }
  }
}
</script>

<style lang="scss" scoped>
.special-edition-tip-modal-content {
  .tips {
    margin-bottom: 24px;
  }

  .tips-content-link {
    color: #1890ff;
    cursor: pointer;
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
